<div class="empty-state">
  <div class="mat-headline-4 voicemail-setup-title">Setup a voice mailbox</div>
  <div class="mat-body-2 voicemail-setup-text">
    Setup a mailbox to manage voice messages and custom greetings.
  </div>
  <button
    mat-flat-button
    [routerLink]="viewsLink"
    [attr.data-cy]="e2Locator"
    color="primary"
    class="voicemail-setup-voicemailbox"
  >
    Setup voice mailbox
  </button>
  <div class="mat-body-2 voicemail-pricing">
    {{ pricingText }}
  </div>
</div>
